import { compact, flow, map, cond, stubTrue, constant } from 'lodash/fp'
import baseForm from 'e-submission/domain/data-model/form'
import { insuredHealth, payerHealth } from 'e-submission/domain/data-model/form/pages/health'
import signature from './signature'
import { submit } from 'e-submission/domain/data-model/form/pages/submit'
import { appendBefore, concatWith, createPageCreator, deepAppend } from 'e-submission/domain/data-model/form/utils'
import dividendField from '../product-term-life/dividendField'
import { getQuickQuoteProductCode } from 'e-submission/domain/data-model/form/selectors'
import VALUES from 'core/data-model/constants/values'

export default (app) => {
  const createPage = createPageCreator(app)
  const productCode = getQuickQuoteProductCode(app)

  return flow(
    baseForm,
    map(createPage),
    concatWith([createPage(signature(app)), createPage(submit())]),
    appendBefore(null, 'FATCA', [createPage(insuredHealth(app)), createPage(payerHealth(app))]),
    cond([
      [
        constant(VALUES.PRODUCT_GIO_HAVE_CHOOSE_DIVIDEND.includes(productCode)),
        deepAppend(
          [['insured', 'sections'], ['personal', 'questions'], ['insured.motorcycleUsage']],
          dividendField(app)
        ),
      ],
      [stubTrue, (form) => form],
    ]),
    compact
  )(app)
}
